import { render, staticRenderFns } from "./NewTimes2.vue?vue&type=template&id=6526c0d6&scoped=true&"
import script from "./NewTimes2.vue?vue&type=script&lang=js&"
export * from "./NewTimes2.vue?vue&type=script&lang=js&"
import style0 from "./NewTimes2.vue?vue&type=style&index=0&id=6526c0d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6526c0d6",
  null
  
)

export default component.exports